import { Title } from "components/misc";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Button, Container, Icon } from "design-react-kit";
import { AdminLessonLiveClassMaterialForm } from "components/forms/admin/AdminLessonLiveClassMaterialForm";

class LessonLiveClassMaterialDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idMaterial:
        parseInt(this.props.match.params.id) > 0
          ? this.props.match.params.id
          : 0,
      title:
        parseInt(this.props.match.params.id) > 0
          ? "Gestione materiale didattico"
          : "Nuovo materiale didattico",
    };
  }

  render() {
    return (
      <section className="my-4">
        <Container>
          <Button
            color="primary"
            outline
            onClick={() => window.history.back()}
            className="mx-5 float-right"
          >
            <Icon icon="it-arrow-left" /> TORNA INDIETRO
          </Button>
          <Title>{this.state.title}</Title>
          {
            <AdminLessonLiveClassMaterialForm
              idMaterial={this.state.idMaterial}
            />
          }
        </Container>
      </section>
    );
  }
}

export default withRouter(LessonLiveClassMaterialDetail);
